import styled from "styled-components";

export const DayListWrapper = styled.div`
  padding: 16px;
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #fafbfc;
  border-bottom: 1px solid #e8ecf1;
`;

export const DayTabs = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 4px;

  /* Hide scrollbar but keep functionality */
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const DayTab = styled.button<{ $selected: boolean; $current: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border: none;
  background: ${({ $selected, $current }) => {
    if ($selected) return "linear-gradient(135deg, #0066cc 0%, #0052a3 100%)";
    if ($current) return "#e3f2fd";
    return "#ffffff";
  }};
  color: ${({ $selected, $current }) => {
    if ($selected) return "#ffffff";
    if ($current) return "#0066cc";
    return "#5c6f82";
  }};
  border-radius: 8px;
  font-size: 14px;
  font-weight: ${({ $selected }) => ($selected ? "600" : "500")};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: ${({ $selected }) => ($selected ? "0 2px 8px rgba(0, 102, 204, 0.25)" : "0 1px 3px rgba(0, 0, 0, 0.06)")};

  &:hover {
    background: ${({ $selected, $current }) => {
      if ($selected) return "linear-gradient(135deg, #0052a3 0%, #003d7a 100%)";
      if ($current) return "#bbdefb";
      return "#f3f5f7";
    }};
    transform: translateY(-1px);
    box-shadow: ${({ $selected }) =>
      $selected ? "0 4px 12px rgba(0, 102, 204, 0.3)" : "0 2px 6px rgba(0, 0, 0, 0.1)"};
  }

  &:active {
    transform: translateY(0);
  }
`;
